/***
 *
 *
 * @description
 * @author jinshakappil
 */

import React, { useEffect, useState } from 'react';

import { Appointments, Bills, Opreg, Opvisits } from '../../../../models';

import './visit-info.scss';

import moment from 'moment';

import { Skeleton, Typography, Avatar, Row, Select, Form, Col } from 'antd';

import { UserOutlined } from '@ant-design/icons';

import { Card, DateUtils, Location, useTranslation } from 'soxo-bootstrap-core';

import DisplayNature from '../../../common/components/display-nature/display-nature';

import OpregSearch from '../../../candidate-visit/opreg-search';
import Bill from '../../../../models/bill';
import { getInitials } from '../../../../utils/common.utils';

const { Option } = Select;

const { Title, Text } = Typography;

const formItemLayout = {
    layout: 'horizontal',
};
/**
 * Display the OPREG data of the VISIT
 */
export default function VisitInfo({
    visit_id,
    guestData,
    mode,
    reference_number,
    disableFields,
    enableBillnumber,
    callback,
    startLoading,
    disableCheckBox,
    onReceiveGuestDetails,
    // The attribute readOnlyMode is used to disable the bill number and hide the OpregSearch component.
    readOnlyMode,
    disableGuestChange,
    generateAiReportModal,
    isEditMode,
}) {
    const [loading, setLoading] = useState(false);

    const { t, i18n } = useTranslation(); // To Translate to another language

    var [patient, setPatient] = useState([]);

    var urlParams = Location.search();

    useEffect(() => {
        if (reference_number) {
            getGuestInformation(reference_number);
        } else if (visit_id) {
            getPatient();
            /**If it is for manage ai report ,set the guest data directly without calling api*/
        } else if (guestData) {
            setPatient({ opReg: guestData });
        }
    }, []);

    /**
     * patient personal information get from opreg
     */
    function getPatient() {
        setLoading(true);

        Opvisits.visitInfo(visit_id).then((result) => {
            if (result.result.length) {
                let opreg = result.result[0];

                setPatient(opreg);
            }

            setLoading(false);
        });
    }
    /**
     *
     * Loading  guest information details
     */
    // function getGuestInformation() {
    //     setLoading(true);
    //     Opreg.loadGuestInformation(reference_number, mode).then(result => {
    //         let data = result.data;

    //         setPatient({ opReg: data });

    //         setLoading(false);
    //     });
    // }
    /**
     *
     * Load guest information
     */
    function getGuestInformation(reference_number) {
        setLoading(true);
        Opreg.getOpregDetails(reference_number).then((result) => {
            let data = result.result;

            data = {
                // first_name: data.op_fname,
                // last_name: data.op_lname,
                name: data.PatientName,
                dob: data.Dob,
                gender: data.Gender,
                age: data.Age,
                opno: data.OpNo,
                email_address: data.Email,
                mobile_number: data.Mobile,
                nature: data.nature,
                emiratesId: data.NationalId,

                // blood_group: data.op_bloodgroup,
            };

            setPatient({ opReg: data });

            // setNature(data.natureptr);

            // On Receive the guest details we have to inform the parent
            onReceiveGuestDetails(data);

            setLoading(false);
        });
    }

    let { opReg = {} } = patient;

    // changing reference number while changing guest
    if (opReg.op_number) {
        reference_number = opReg.op_number;
    }

    // for getting nature of the guest
    const nature = opReg.nature;

    return (
        <>
            {loading ? (
                <Card className="visit-info card card-shadow">
                    <Skeleton />
                </Card>
            ) : (
                <Card className="visit-info card card-shadow">
                    {nature ? <DisplayNature nature={nature} /> : null}

                    <Row align="middle" gutter={[8, 8]} wrap={false}>
                        <Col>
                            <Avatar size={48} style={{ backgroundColor: '#a0c4ff' }}>
                                {getInitials(opReg.name)}
                            </Avatar>
                        </Col>

                        <Col flex="auto">
                            <Row justify="space-between" align="middle" gutter={[8, 8]} wrap>
                                <Col>
                                    <Text strong style={{ fontSize: 16 }}>
                                        {opReg.name}
                                    </Text>
                                </Col>
                                <Col>
                                    <div className="opreg-search">
                                        {!disableGuestChange && enableBillnumber && !readOnlyMode && !isEditMode && !generateAiReportModal ? (
                                            <OpregSearch
                                                enableVisit={false}
                                                mode={mode}
                                                disableCheckBox={disableCheckBox}
                                                callback={(record) => {
                                                    record = {
                                                        ...record,
                                                        opno: record.op_number,
                                                        mobile_number: record.mobile1,
                                                        email_address: record.email,
                                                        name: record.first_name,
                                                        age: record.age_year,
                                                        emiratesId: record.emirates_id,
                                                        nature: record.nature,
                                                    };

                                                    onReceiveGuestDetails(record);
                                                    setPatient({ opReg: record });
                                                }}
                                                model={Appointments}
                                                title={'Change Guest'}
                                            />
                                        ) : null}
                                    </div>
                                </Col>
                                {/* Only show BillNumber here on larger screens */}
                                {/* {!screens.xs && enableBillnumber && reference_number && (
                                    <Col>
                                        <BillNumber
                                            opno={reference_number}
                                            callback={(values, bills) => callback(values, bills)}
                                            readOnlyMode={readOnlyMode}
                                        />
                                    </Col>
                                )} */}
                            </Row>
                            <Row justify="space-between" align="middle">
                                <Col>
                                    <Text type="secondary">
                                        <strong>{opReg.opno}</strong>
                                    </Text>
                                </Col>
                               
                            </Row>
                            <Row justify="space-between" align="middle">
                                <Col>
                                    <Text type="secondary">
                                        Dob: <strong>{opReg.dob ? DateUtils.formatDate(opReg.dob) : '-'}</strong>
                                    </Text>
                                </Col>
                                
  
                                {/* <Col span={24}>
                                    <Text type="secondary">
                                        Dob: <strong>{opReg.dob ? DateUtils.formatDate(opReg.dob) : '-'}</strong>
                                    </Text>
                                </Col> */}
                                {opReg?.gender && (
                                    <Col span={24}>
                                        <Text type="secondary">{`${opReg.gender} | ${opReg.age}`}</Text>
                                    </Col>
                                )}
                            </Row>
                        </Col>
                    </Row>

                    {enableBillnumber && reference_number && (
                        <Col span={24}>
                            <BillNumber opno={reference_number} callback={(values, bills) => callback(values, bills)} readOnlyMode={readOnlyMode} />
                        </Col>
                    )}
                </Card>
            )}
        </>
    );
}

/**
 *Bill number Loading
 * @param {*} opno
 * @returns
 */
function BillNumber({ opno, callback, readOnlyMode }) {
    var [billno, setBillNo] = useState([]);
    const [form] = Form.useForm();
    const { t, i18n } = useTranslation(); // To Translate to another language

    useEffect(async () => {
        await getBillNumbers(opno);
    }, [opno]);

    /**
     * Loading bill  numbers
     * @param {*} opno
     */
    async function getBillNumbers(opno) {
        await Bills.loadbilllnumbers(opno).then((result) => {
            // If bill is present set the zeroth elemnt as the initial value for bill_id
            if (result && result.result && result.result.length > 0) {
                setBillNo(result.result);
                // Set initail values
                callback(result.result[0].opb_id, result.result);
                const initailValue = result.result[0].opb_bno + '_' + moment(result.result[0].opb_dt).format('DD/MM/YYYY');
                form.setFieldsValue({ bill_no: initailValue });
            }
        });
    }

    return (
        <>
            <Form {...formItemLayout} form={form}>
                <Form.Item
                    name="bill_no"
                    style={{ marginBottom: 0 }}
                    // label={t('Bill No')}
                >
                    <Select
                        //// Disable the Select component if `readOnlyMode` is true
                        disabled={readOnlyMode ? readOnlyMode : false}
                        onSelect={(event) => {
                            callback(event, billno);
                        }}
                    >
                        {billno.map((mode) => {
                            return <Option value={mode.opb_id}>{mode.opb_bno + '_' + moment(mode.opb_dt).format('DD/MM/YYYY')}</Option>;
                        })}
                    </Select>
                </Form.Item>
            </Form>
        </>
    );
}
